
export const controllerEndpoints = {
  ACTOR: 'actor',
  USER: 'users',
  ACTIVITY: 'activity',
  ACTIVITY_AUTH: 'activity/auth',
  PDF_DOCUMENT: 'document',
  PROCESS: 'process',
  SPLUG_DEFINITION: 'splugs',
  SERVER_SIDE_EVENTS: 'event',
  SPLUG_PARAMETERS_CONFIGURATION: 'sigconfig',
  TASK: 'task',
  WATCHER: 'watcher',
  ROLE: 'roles',
  TEAM: 'team'
} as const
